import ZeissButton from '@components/button';
import { Modal, Space } from 'antd';
import './index.scss';

interface NoticeRevertModalPropsTS {
  open?: boolean;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  title?: string;
  children?: any;
}

const RevertModal = (props: NoticeRevertModalPropsTS) => {
  const {
    open,
    onConfirm,
    onCancel,
    confirmText,
    cancelText,
    title,
    children
  } = props;
  return (
    <Modal
      width={520}
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose={true}
      centered
    >
      <div className="pc-revert-layout">
        <div className="pc-revert-title">{title}</div>
        <div>{children}</div>
        <Space className="pc-revert-footer" size="middle">
          <ZeissButton className="pc-normal-btn" onClick={onCancel}>
            {cancelText || '取消'}
          </ZeissButton>
          <ZeissButton className="pc-danger-btn" onClick={onConfirm}>
            {confirmText || '确认'}
          </ZeissButton>
        </Space>
      </div>
    </Modal>
  );
};

export default RevertModal;
